import { SET_DEPARTURES } from './types';

export const SetDeparture = value => {
    return dispatch => dispatch({type:SET_DEPARTURES, payload:value});
}